<script setup lang="ts">
import { useAssistantSettingsStore } from "@/stores/assistantSettingsStore";

const { assistantSettings } = useAssistantSettingsStore();
</script>

<template>
  <div class="assistant-avatar">
    <div class="inner">
      <div class="background" />
      <!-- <img src="@/assets/images/avatar.png" class="image" /> -->
      <img :src="`${assistantSettings.images.avatar}`" class="image" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.assistant-avatar {
  position: relative;
  font-size: 0;
}

.inner {
  position: relative;
  aspect-ratio: 5/6;
  max-height: 100%;
  border-radius: 0 0 9999px 9999px;
  overflow: hidden;
}

.background {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow:
    inset 0 0 10px rgba(0, 0, 0, 0.1),
    inset 0 0 40px rgba(255, 255, 255, 0.3);
  border-radius: 100%;
  // background: color-contrast(
  //   var(--auth-body-background-color) vs #000000,
  //   #ffffff
  // );
  background: rgba(0, 0, 0, 0.1);
  aspect-ratio: 1;
}

.image {
  position: relative;
  max-width: 100%;
  max-height: 100%;
}
</style>
